import React from 'react'

const EOLtesting = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">EOL Testing</a>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/eol_testing.png' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>End Of Line (EOL) Testing for Automative:</h2>
                        <p className="mbot25">
                            The EOL testing procedure comprises a series of rigorous checks designed to evaluate the
                            complete functionality of the ECU. The process includes various testing phases, such as
                            Initialization, Verification, Calibration, and Functional Testing.
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Initialization:</h4>
                        <p className="mbot25">
                            In this stage, the ECU’s firmware is installed, and its memory is initialized. This is where the
                            ECU gets the software that enables it to perform its functions.
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Verification: </h4>
                        <p className="mbot25">
                            Once the ECU is initialized, the next step is the verification of the installed firmware and
                            hardware components of the ECU. It involves checking whether the installed firmware is the correct
                            version and if the hardware components are functioning as expected.
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Calibration:</h4>
                        <p className="mbot25">
                            Calibration involves tuning the ECU parameters to optimize its performance. For instance, parameters
                            like fuel injection timings in an engine control unit can be calibrated to ensure the engine runs
                            efficiently under different operating conditions.
                        </p>
                        <h4 style={{ textDecoration: "underline" }}>Functional Testing:</h4>
                        <p className="mbot25">Functional tests are conducted to verify if the ECU is functioning as intended.
                            This includes testing the ECU’s various interfaces, such as digital inputs/outputs, analog
                            inputs/outputs, and communication interfaces.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EOLtesting
